import { render, staticRenderFns } from "./BackProductType.vue?vue&type=template&id=4733e7fe&scoped=true"
import script from "./BackProductType.vue?vue&type=script&lang=js"
export * from "./BackProductType.vue?vue&type=script&lang=js"
import style0 from "./BackProductType.vue?vue&type=style&index=0&id=4733e7fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4733e7fe",
  null
  
)

export default component.exports